module.exports = __webpack_public_path__ + "sharp-sans-bold-italic-dfa06f3c5e5b52d9367cd1b7cb7e8774.bundle.woff2";